var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelpcenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.5V10.5C2.5 8.51088 3.29018 6.60322 4.6967 5.1967C6.10322 3.79018 8.01088 3 10 3C11.9891 3 13.8968 3.79018 15.3033 5.1967C16.7098 6.60322 17.5 8.51088 17.5 10.5V15.5",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 16.3333C17.5 16.7753 17.3244 17.1992 17.0118 17.5118C16.6993 17.8244 16.2754 18 15.8333 18H15C14.558 18 14.134 17.8244 13.8215 17.5118C13.5089 17.1992 13.3333 16.7753 13.3333 16.3333V13.8333C13.3333 13.3913 13.5089 12.9673 13.8215 12.6548C14.134 12.3422 14.558 12.1666 15 12.1666H17.5V16.3333ZM2.5 16.3333C2.5 16.7753 2.67559 17.1992 2.98816 17.5118C3.30072 17.8244 3.72464 18 4.16667 18H5C5.44203 18 5.86595 17.8244 6.17851 17.5118C6.49107 17.1992 6.66667 16.7753 6.66667 16.3333V13.8333C6.66667 13.3913 6.49107 12.9673 6.17851 12.6548C5.86595 12.3422 5.44203 12.1666 5 12.1666H2.5V16.3333Z",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpcenter);
export default __webpack_public_path__ + "static/media/helpcenter.f19e079fd9fe9ce83d69711564b877a7.svg";
export { ForwardRef as ReactComponent };